import * as types from "../actions/types";



const initialState = {
  list: [],
  params: null,
  loading: false
};


export default function reports(state = initialState, action) {
  switch (action.type) {
    case types.SET_REPORTS_LIST:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_REPORTS_PARAMS:
      return {
        ...state,
        params: action.payload
      };
    case types.SET_REPORTS_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}